// src/config/constants.ts — Değişmez yapısal sabitler (sim adımı, kapsül geometrisi, havuz boyları).
// Ayarlanabilir oyun sayıları tuning.ts'de; burada yalnız kodun yapısını belirleyen (dizi boyu, adım süresi, geometri) değerler var.

/** Sim frekansı ve tick süresi (DESIGN: 60 Hz sabit adım, 1 t = 16.7 ms). */
export const TICK_HZ = 60;
export const TICK_DT = 1 / TICK_HZ;
/** Klip verisi örnekleme frekansı (anim-metrics / clipdata.json 60 Hz) — TICK_HZ ile aynı; frameOf(t) = round(t·CLIP_FPS). */
export const CLIP_FPS = 60;
/** Bir klip karesi (sn) — kök hareket pencere kuralı `window[0] ≥ clipStart − CLIP_FRAME` (DESIGN §4). */
export const CLIP_FRAME = 1 / CLIP_FPS;

// ── Kapsül / hurtbox (DESIGN §3, §4, ARCHITECTURE §4) ──
/** Fizik kapsülü yarıçapı ve yüksekliği (ayak y 0 → tepe 2.2). */
export const CAP_R = 0.5;
export const CAP_H = 2.2;
/** Dik hurtbox: yarıçap 0.45 (kapsülden küçük, saldıran lehine), Y aralığı [0.1, 2.2]. */
export const HURT_R = 0.45;
export const HURT_Y0 = 0.1;
export const HURT_Y1 = 2.2;
/** Yatan hurtbox: yatay kapsül, merkez y 0.35, r 0.45, ileri ±0.8 (bakış yönünde). */
export const LYING_HURT_Y = 0.35;
export const LYING_HURT_HALF = 0.8;
/** Yatan dövüşçünün kapsül Y aralığı [0, 0.9] — üstünden geçilebilir (itişme). */
export const LYING_CAP_H = 0.9;
/** Kapsül ayırma (ARCHITECTURE §4.1, FT değerleri): push = min(overlap·SEP_RATE, SEP_MAX) u/tick; d < SEP_EPS → yön hashNoise. */
export const SEP_RATE = 0.45;
export const SEP_MAX = 0.06;
export const SEP_EPS = 1e-4;
/** Zemine yapışma toleransı (ARCHITECTURE §4.2): vel.y ≤ 0 ∧ pos.y − ground ≤ GROUND_SNAP → grounded. */
export const GROUND_SNAP = 0.08;

/** Kill plane (DESIGN §8): y < −8 → ring-out. tuning EDGE.killY ile aynı; burada yapısal referans. */
export const KILL_Y = -8;

// ── Havuz / dizi boyları ──
export const MAX_FIGHTERS = 8;        // 1 oyuncu + ≤ 7 bot (DESIGN §13); hitMask bit sayısı
export const MAX_ITEMS = 4;           // sahnede ≤ 2 eşya + dual iki Item + uçan/kaybolan payı
export const MAX_HIT_GROUPS = 2;      // hitMask[group]; yalnız Dual W2 sol ve 2H Spin 2. pencere grup 1 (DESIGN §4)
export const EVENT_CAP = 256;         // EventList kapasitesi; taşarsa düşer (ARCHITECTURE §2)
export const RECENT_HITS_RING = 16;   // Fighter.recentHitTicks halka boyu (84 t pencerede n sayımı)
export const STALE_QUEUE = 6;         // Fighter.staleMove/staleTick kuyruk boyu (150 t bayatlama)
export const BTN_BITS = 8;            // InputBuffer.pressTick/releaseTick boyu (Btn bit indeksi 0..7)
/** "Yok" sabitleri (Fighter alanları hep sayı: null yerine). */
export const NO_ID = -1;
export const NO_TICK = -100000;
